import { render } from "./ChallengeView.vue?vue&type=template&id=0e691ec4&scoped=true"
import script from "./ChallengeView.vue?vue&type=script&lang=js"
export * from "./ChallengeView.vue?vue&type=script&lang=js"

import "./ChallengeView.vue?vue&type=style&index=0&id=0e691ec4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e691ec4"]])

export default __exports__